<template>
  <div>
    <v-snackbar v-model="snackbar" :color="type" bottom left text :timeout="timeout">
      <div v-for="(text, index) in text.split('\n')" :key="index">
        {{ text }}
      </div>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "Snackbar",
  props: {
    type: {
      type: String,
      default: "info",
      require: false,
    },
    text: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      timeout: 6000,
      snackbar: true,
    };
  },
  watch: {
    text() {
      this.snackbar = true;
    },
  },
};
</script>

<style scoped></style>
